import { SupermodalComponent } from "@app/components/common/supermodal.component";
import { ListingService } from "@app/services/listing.service";
import { Component } from "@angular/core";
import { ViewChild } from "@angular/core";
import { Category, Listing } from "@app/data/listing";
import * as _ from "underscore";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { Input } from "@angular/core";
import { OnDestroy } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { OnInit } from "@angular/core";
import { UserService } from "@app/services/user.service";

export class Node {
  id: string;
  data: any;
  selected: boolean = false;
  children: Node[] = [];
  loaded: boolean = false;
  selectedCount: number = 0;

  constructor(data: any) {
    this.id = data.id;
    this.data = data;
  }

  merge(node: Node) {
    this.selected = node.selected;
    this.children = node.children;
    this.loaded = node.loaded;
    this.selectedCount = node.selectedCount;
  }
}

@Component({
  selector: "listings-selector",
  templateUrl: "./listings-selector.component.html",
})
export class ListingsSelectorComponent implements OnInit, OnDestroy {
  lastPageLoaded: number;
  @ViewChild("selectorSupermodal")
  selectorSupermodalComponent: SupermodalComponent;
  @Input()
  id: string;
  nextPageUrl: string;
  selectedCategoryNode: Node;
  categoryNodes: Node[] = [];
  @Input("selection")
  savedNodes: Node[] = [];
  @Output()
  selectionChange = new EventEmitter<Node[]>();

  @Input()
  listings: Listing[];
  @Output()
  listingsChanged = new EventEmitter<Listing[]>();
  listingsVisible: boolean = false;

  categoriesFilter: string = "";
  listingsFilter: string = "";
  isLoadingCategories: boolean = false;
  isLoadingListings: boolean = false;
  isLoadingNextPage: boolean = false;
  loadingCategoryId: string;
  hasAccessToProductCategories: boolean = false;
  pageIndex: number = -1;

  constructor(
    private listingService: ListingService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService.hasAccess("product-categories").then((hasAccess) => {
      this.hasAccessToProductCategories = hasAccess;
      if (this.hasAccessToProductCategories) {
        this.loadCategories();
      } else {
        this.pageIndex = 1;
        let node = new Node({});
        if (this.savedNodes && this.savedNodes.length > 0) {
          node.merge(this.savedNodes[0]);
        }
        this.categoryNodes.push(node);
        this.showListings(node);
      }
    });
  }

  loadCategories() {
    this.isLoadingCategories = true;
    this.listingService.getCategories().then((categories) => {
      this.isLoadingCategories = false;
      this.categoryNodes = [];
      let sortedCategories = _.sortBy(categories, "title");
      sortedCategories.forEach((category, index) => {
        let categoryNode = new Node(category);
        let savedNode = _.findWhere(this.savedNodes, {
          id: category.id,
        }) as Node;
        if (savedNode) {
          categoryNode.merge(savedNode);
        }
        this.categoryNodes.push(categoryNode);
      });
      this.refreshSelectedListings();
    });
  }

  // restoreSavedNode(): Node[] {
  //     let savedNodes;
  //     // let listingsSelector = localStorage.getItem(`listings-selector-${this.id}`);
  //     // if (listingsSelector) {
  //     //     savedNodes = JSON.parse(listingsSelector);
  //     // }
  //     // console.log('restored node', savedNodes);
  //     return savedNodes;
  // }

  showSelector() {
    this.selectorSupermodalComponent.open();
  }

  refreshNodesSelected(node: Node) {
    let selectedCount = 0;
    // node.forEach(node => {
    if (node.selected) {
      selectedCount += node.children.length;
    }
    node.children.forEach((child) => {
      let listing = child.data as Listing;
      if (node.selected && !child.selected) {
        selectedCount -= 1;
      }
      if (!node.selected && child.selected) {
        selectedCount += 1;
      }
    });
    // });
    node.selectedCount = selectedCount;
    this.refreshSelectedListings();
  }

  public refreshSelectedListings() {
    this.listings.splice(0, this.listings.length);
    this.categoryNodes.forEach((categoryNode) => {
      categoryNode.children.forEach((listingNode) => {
        if (listingNode.selected) {
          this.listings.push(listingNode.data);
          // let index = _.findIndex(this.listings, { _id: listingNode.data._id });
          // if (index > -1) {
          //     this.listings[index] = listingNode.data;
          // } else {
          //     this.listings.push(listingNode.data);
          // }
        }
      });
    });
    this.listingsChanged.emit(this.listings);
    this.save();
  }

  selectCategory($event, categoryNode: Node, select: boolean) {
    categoryNode.selected = select;
    categoryNode.children.forEach((child) => {
      child.selected = categoryNode.selected;
    });
    this.pageIndex = -1;
    this.loadListings(categoryNode, select);
    this.nextPageUrl = null;
    $event.stopPropagation();
  }

  loadListings(categoryNode: Node, selected: boolean = null) {
    let categoryId;
    let isCustomCollection;
    if (categoryNode.id) {
      let category = categoryNode.data as Category;
      categoryId = category.id;
      isCustomCollection = category.isCustomCollection;
    }
    this.isLoadingListings = true;
    this.isLoadingNextPage = this.pageIndex > 1;
    this.loadingCategoryId = categoryId;
    const useUrl =
      categoryNode.children &&
      categoryNode.children.length > 0 &&
      this.nextPageUrl != null;
    this.listingService
      .getListings(
        "",
        categoryId,
        this.pageIndex,
        isCustomCollection,
        this.nextPageUrl,
        useUrl
      )
      .then((listings) => {
        this.loadingCategoryId = null;
        this.lastPageLoaded = this.pageIndex;
        this.isLoadingListings = false;
        let existingChildrenNodes = categoryNode.children;
        if (this.pageIndex <= 1) {
          categoryNode.children = [];
        } else {
          this.isLoadingNextPage = false;
        }
        categoryNode.loaded = true;
        listings.forEach((listing, index) => {
          let existingNodeIndex = _.findIndex(categoryNode.children, (node) => {
            return node.data.id === listing.id;
          });
          if (existingNodeIndex > -1) {
            return;
          }

          listing.category = categoryNode.data.title;
          let newNode = new Node(listing);
          let existingNode = _.findWhere(existingChildrenNodes, <any>((
            node
          ) => {
            return node.data.id === listing.id;
          }));
          if (selected != null) {
            newNode.selected = selected;
          } else {
            let existingListing = _.findWhere(this.listings, {
              id: listing.id,
            });
            if (existingNode) {
              newNode.merge(existingNode);
            }
            newNode.selected = typeof existingListing !== "undefined";
          }
          categoryNode.children.push(newNode);

          if (index === listings.length - 1) {
            this.nextPageUrl =
              categoryNode.children && categoryNode.children.length > 0
                ? categoryNode.children[categoryNode.children.length - 1].data
                    .next_page_url
                : "";
          }
        });
        listings = _.sortBy(listings, "title");
        this.refreshNodesSelected(categoryNode);
      });
  }

  showListings(categoryNode: Node) {
    this.pageIndex = 1;
    this.selectedCategoryNode = categoryNode;
    this.listingsFilter = "";
    this.listingsVisible = true;
    this.loadListings(categoryNode);
  }

  showCategories() {
    this.listingsVisible = false;
    this.categoriesFilter = "";
  }

  selectListing($event, listingNode, select) {
    listingNode.selected = select;
    if (!select) {
      this.selectedCategoryNode.selected = false;
    }
    $event.stopPropagation();
    this.refreshNodesSelected(this.selectedCategoryNode);
  }

  save() {
    this.selectionChange.emit(this.categoryNodes);
    // console.log('save', this.categoryNodes);
    // let listingsSelector = JSON.stringify(this.categoryNodes);
    // localStorage.setItem(`listings-selector-${this.id}`, listingsSelector);
  }

  filterCategory(categoriesFilter: string, category: Category) {
    var lowerCaseFilter = categoriesFilter.toLowerCase();
    return category.title.toLowerCase().indexOf(lowerCaseFilter) > -1;
  }

  filterListing(listingsFilter: string, listing: Listing) {
    var lowerCaseFilter = listingsFilter.toLowerCase();
    return listing.title.toLowerCase().indexOf(lowerCaseFilter) > -1;
  }

  onScroll() {
    if (this.lastPageLoaded === this.pageIndex) {
      this.pageIndex += 1;
      this.loadListings(this.selectedCategoryNode);
    }
  }

  ngOnDestroy(): void {
    this.save();
  }
}
